(function () {
    angular
        .module('app')
        .directive('vlite', setvlite);

    setvlite.$inject = ['$timeout', '$window'];
    function setvlite($timeout, $window) {
        return {
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                    let options = {
                        controls: true,
                        volume: true,
                        fullscreen: false,
                        loop: false,
                        muted: false,
                        playPause: true,
                        progressBar: true,
                        time: true,
                        bigPlay: true,
                    };
                    let vlite;
                    let provider = null;

                    if ($attrs.vlite.includes("vimeo")) {
                        provider = "vimeo";
                        options.progressBar = false
                        options.controls = false
                    }
                    let vliteConfig = {
                        options: options,
                    };
                    if (provider) {
                        vliteConfig.provider = provider;
                    }

                    vlite = new $window.Vlitejs(element[0], vliteConfig);

                   
                });
            }
        }
    }
})();
